import React from "react";

function SourceField({source}){
	let Rexp = /(https?:\/\/(([-\w\.]+)+(:\d+)?(\/([\w/_\.]*(\?\S+)?)?)?))/g;
	let result = '';
	if(source && source.text){
		result = source.text.replace(Rexp,"<a href=\"$1\" target=\"_blank\">$1</a>");
	}
	return(
			<li id={source.sourceId}>{source.sourceId}.&nbsp;<span dangerouslySetInnerHTML={{ __html: result }}/></li>
	)
}

export default SourceField;